import React from 'react';

import Translation from '@swf/components/Translation/Translation';

import { RangeOption } from '../utils/utils';

import { TXTCLI_Never, TXTWCL_After, TXTWCL_On } from './occurrenceRangeOptions.messages.json';

export default [
  {
    text: <Translation {...TXTCLI_Never} />,
    value: RangeOption.Never
  },
  {
    text: <Translation {...TXTWCL_On} />,
    value: RangeOption.On
  },
  {
    text: <Translation {...TXTWCL_After} />,
    value: RangeOption.After
  }
];
